import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/components/home/News.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/components/home/Promotion.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/components/home/SectionMenu.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/components/home/Slider.tsx");
